/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { send } from 'xstate';
const INITIAL_CONTEXT = {
  idle: {},
  SIGN_IN_USER: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.signIn.user',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'SIGN_IN_USER' },
      },
    },
    SIGN_IN_USER: {
      invoke: {
        id: 'signInUser',
        src: 'signInUser',
        onDone: {
          target: 'CHECK_TOKEN_TYPE',
          actions: ['successAction'],
        },
        onError: {
          target: 'SIGN_IN_USER_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    CHECK_TOKEN_TYPE: {
      entry: send('CHECK_TOKEN_TYPE', { to: 'checkTokenType' }),
      invoke: {
        id: 'checkTokenType',
        src: 'checkTokenType',
      },
      on: {
        SIGN_IN_TOKEN: {
          target: 'GET_ACCESS_TOKEN',
          actions: ['successAction'],
        },
        ACCESS_TOKEN: {
          target: 'SIGN_IN_USER_SUCCESS',
          actions: ['successAction'],
        },
        ERROR: {
          target: 'SIGN_IN_USER_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_ACCOUNT_SELECTION: {
      entry: (context: any, event: any) => {
        console.log('render account selection event =>', context);
      },
      on: {
        GET_ACCESS_TOKEN: {
          target: 'GET_ACCESS_TOKEN',
          actions: ['successAction'],
        },
      },
    },
    GET_ACCESS_TOKEN: {
      invoke: {
        id: 'getAccessToken',
        src: 'getAccessToken',
        onDone: {
          target: 'SIGN_IN_USER_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'SIGN_IN_USER_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    SIGN_IN_USER_SUCCESS: {
      type: 'final',
    },
    SIGN_IN_USER_FAILED: {
      on: {
        START: { target: 'SIGN_IN_USER' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
